import { useEffect, useState } from 'react';
import { About } from './About';
import { FeedbackPrompt } from './FeedbackPrompt';
import { Landing } from './Landing';
import { Workspace } from './Workspace';

type Page = 'home' | 'workspace' | 'about';

function pageFromLocation(): Page {
  if (location.pathname.startsWith('/app')) return 'workspace';
  if (location.pathname.startsWith('/about')) return 'about';
  return 'home';
}

export function App() {
  const [page, setPage] = useState<Page>(pageFromLocation);
  const [theme, setTheme] = useState<'dark' | 'light'>(() => {
    const saved = localStorage.getItem('rtl-ui-theme');
    if (saved === 'dark' || saved === 'light') return saved;
    return matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  });
  const go = (next: Page) => {
    history.pushState({}, '', next === 'workspace' ? '/app' : next === 'about' ? '/about' : '/');
    setPage(next);
  };
  useEffect(() => {
    const onPop = () => setPage(pageFromLocation());
    addEventListener('popstate', onPop);
    return () => removeEventListener('popstate', onPop);
  }, []);
  useEffect(() => {
    localStorage.setItem('rtl-ui-theme', theme);
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
  }, [theme]);
  useEffect(() => {
    document.title = page === 'workspace' ? 'Ortl Workbench' : page === 'about' ? 'About Ortl — Hardware intelligence' : 'Ortl — RTL Hardware Visualizer';
  }, [page]);
  const toggleTheme = () => setTheme((current) => current === 'dark' ? 'light' : 'dark');
  const content = page === 'workspace'
    ? <Workspace goHome={() => go('home')} theme={theme} toggleTheme={toggleTheme} />
    : page === 'about'
      ? <About goHome={() => go('home')} openWorkspace={() => go('workspace')} theme={theme} toggleTheme={toggleTheme} />
      : <Landing openWorkspace={() => go('workspace')} openAbout={() => go('about')} theme={theme} toggleTheme={toggleTheme} />;

  return <>
    {content}
    <FeedbackPrompt theme={theme} />
  </>;
}
